import { Strategy } from 'utility-ts-strategy';

export interface ISurveyQuestionDirection {
  queryName: string;
  newState: string;
}

export const SurveyQuestionDirectionStrategy = new Strategy<ISurveyQuestionDirection>({
  NEXT: {
    queryName: 'next',
    newState: 'my.survey-summary'
  },
  PRIOR: {
    queryName: 'prior',
    newState: 'my.survey-intro'
  },
  RESUME: {
    queryName: 'resume',
    newState: 'my.survey-summary'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/strategies/survey_question_direction_strategy.ts